namespace Matrix.Data {
    export interface DataReportFormatterTypeItem {
        FormatterType?: string;
        DisplayName?: string;
        Options?: Serenity.PropertyItem[];
    }
}
